
export default function SQLs_Not_Null() {
  return (
    <div>
      <h1>SQL Not Null</h1>
      <p>Content for SQL Not Null will go here.</p>
    </div>
  );
}
